import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { getMaintenanceMessage } from "@shared/maintenance/maintenance-check";

@Component({
  standalone: true,
  templateUrl: "./maintenance.html",
  styleUrl: "./maintenance.scss",
  imports: [TranslateModule],
})
export class MaintenanceComponent {
  // Message set from the back-office when the maintenance mode was enabled
  readonly message = getMaintenanceMessage();
}
